import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { MCP_WAITLIST_PATH } from '../../data/mcp';
import { useMcpWaitlistPopup } from '../../contexts/McpWaitlistContext';
import { CtaButton } from '../ui/CtaButton';
type McpWaitlistButtonProps = {
  placement: string;
  variant?: 'primary' | 'outline' | 'violet' | 'outlineDark';
  size?: 'md' | 'lg' | 'xl';
  className?: string;
};

/** Opens the MCP waitlist popup. Falls back to /mcp#waitlist as a normal link. */
export function McpWaitlistButton({
  placement,
  variant = 'violet',
  size = 'lg',
  className
}: McpWaitlistButtonProps) {
  const {
    openWaitlist
  } = useMcpWaitlistPopup();
  return <CtaButton href={MCP_WAITLIST_PATH} variant={variant} size={size} className={className} onClick={event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    openWaitlist(placement);
  }} data-id="element-765" data-mp="wo6h7ijakuul">
      Join the MCP waitlist
      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-766" data-mp="2tjm2nsep9g9n" />
    </CtaButton>;
}